/**
 * @generated SignedSource<<70c4080778bb1f51b296de25682ff328>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type TodoResponseType = "IMAGES" | "NUMBER" | "TEXT";
import { FragmentRefs } from "relay-runtime";
export type WorkspaceTodoEditMainResponseType_TodoWorkspace$data = {
  readonly id: string;
  readonly responseDescription: string | null;
  readonly responseType: TodoResponseType | null;
  readonly updatedAtDate: {
    readonly isoString: string;
    readonly " $fragmentSpreads": FragmentRefs<"FormattedDate">;
  } | null;
  readonly updatedBy: {
    readonly id: string;
    readonly name: string;
  } | null;
  readonly " $fragmentType": "WorkspaceTodoEditMainResponseType_TodoWorkspace";
};
export type WorkspaceTodoEditMainResponseType_TodoWorkspace$key = {
  readonly " $data"?: WorkspaceTodoEditMainResponseType_TodoWorkspace$data;
  readonly " $fragmentSpreads": FragmentRefs<"WorkspaceTodoEditMainResponseType_TodoWorkspace">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "WorkspaceTodoEditMainResponseType_TodoWorkspace",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "responseType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "responseDescription",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "UnzonedDate",
      "kind": "LinkedField",
      "name": "updatedAtDate",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "FormattedDate"
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isoString",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "User",
      "kind": "LinkedField",
      "name": "updatedBy",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        },
        (v0/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "type": "TodoWorkspace",
  "abstractKey": null
};
})();

(node as any).hash = "8017adb60813c155e92e209a1bd5ca7a";

export default node;
